import React, {Component} from 'react';
import {
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Col,
  } from 'reactstrap';

import UrlBase from './../api/UrlBase';
import { FaCalendarAlt} from 'react-icons/fa';
import urlBase from './../api/UrlBase';
class ModalPostulacion extends Component {

    render(){
        const {entrada, isOpen, toggle, galeria} = this.props; 

        return (

            <Modal  isOpen={isOpen} toggle={toggle}   backdrop="static" className="modal-grande">
                <ModalHeader  toggle={toggle} >
                </ModalHeader>
                <ModalBody>      

                  <Row style={{marginBottom:30}}>
                      <Col sm={12}>
                        <img src={UrlBase+entrada.imagen} className="imagen-vista-entrada" alt={entrada.titulo}/>
                      </Col>

                      <Col sm={12} className="titulo-entrada-modal">
                        {entrada.titulo}
                      </Col>

                      <Col sm={12} className="fecha-entrada-modal">
                        <FaCalendarAlt /> {entrada.fecha}
                      </Col>

                      <br/><br/><br/>
                      <Col sm={12} className="contenido-entrada-modal">
                        {entrada.encabezado}
                      </Col>
                      <Col sm={12} className="contenido-entrada-modal">
                        {entrada.contenido}
                      </Col>
                      <br/><br/>
                      {  galeria.length >0 &&
                        galeria.map((g, index) => {
                          return (
                             <Col sm={2}  key={g.url+index} className="centrar-s-solo">
                               <img src={urlBase+g.url} className="img-galeria" alt=""/>
                             </Col>
                          )  
                      })


  
                      }
                 
                  </Row>

                </ModalBody>

            </Modal>

        )
    }
};

export default ModalPostulacion;